// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconTableSeating = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M20.51 7.65a52 52 0 00-.39 4.35H16l-1 1v5h2v-4h3v4h2v-1c0-4.463.248-7.31.49-9.078a26 26 0 01.394-2.211l.008-.034.043-.2.003-.012C22.96 5.362 23 5.173 23 5h-2l.002-.05v-.006L21 4.953l-.021.109-.04.184-.008.034-.066.303a28 28 0 00-.356 2.067M3.857 12a58 58 0 00-.365-4.092 36 36 0 00-.419-2.561l-.007-.038-.04-.206-.024-.13-.003-.014v.007L3 5H1c0 .163.037.354.058.466l.003.013.043.22.007.037q.03.143.063.32c.09.474.212 1.158.334 2.107C1.752 10.063 2 13.537 2 18h2l-.001-1H4v-3h3v4h2v-5l-1-1z" />,
    <path d="M13 10h4.25V8H6.75v2H11v8h2z" />
  );
export default SvgIconTableSeating;
